import { changePlanPopupOpened, clickCancelChangePlan, clickConfirmPlanChange, platformizedPackagePickerDowngradeErrorModalClickSrc17Evid2260, platformizedPackagePickerDowngradeErrorModalCloseSrc17Evid2261, platformizedPackagePickerDowngradeErrorModalLoadSrc17Evid2259, platformizedPackagePickerDowngradeSuccessModalClickSrc17Evid2258, platformizedPackagePickerDowngradeSuccessModalLoadSrc17Evid2257, platformizedPackagePickerSelectPlanPageDowngradeModalLoadSrc17Evid2238 } from '@wix/bi-logger-premium-data/v2';
import { BiUtils, getSearchParams } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../../components';
import { useBiLogger } from './useBiLogger';
import { useCommonBiEventsFields } from './useCommonBiEventsFields';
export const useInitDowngradeModalBiEvents = () => {
  const [didInit, setDidInit] = React.useState(false);
  const module = useCurrentModule();
  const {
    setBiEvent
  } = module.SDK;
  const {
    biLogger
  } = useBiLogger();
  const {
    isDowngradeEnabled
  } = getSearchParams();
  const {
    commonBiEventsFields,
    isLoading: isCommonBiEventsFieldsLoading
  } = useCommonBiEventsFields({
    enabled: isDowngradeEnabled
  });
  const isLoading = isCommonBiEventsFieldsLoading;
  React.useEffect(() => {
    if (isLoading || !isDowngradeEnabled) {
      return;
    }
    setBiEvent('onDowngradeModalLoad', _ref => {
      let {
        productId,
        newProductId,
        downgradeType,
        cycle,
        newCycle
      } = _ref;
      const additionalFields = {
        productGuid: productId,
        newProductGuId: newProductId,
        changeType: downgradeType,
        cycle: BiUtils.getBiCycle(cycle),
        newCycle: BiUtils.getBiCycle(newCycle)
      };
      biLogger == null || biLogger.report(
      // 17:7900
      changePlanPopupOpened({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onDowngradeSubmit', _ref2 => {
      let {
        productId,
        newProductId,
        downgradeType,
        cycle,
        newCycle
      } = _ref2;
      const additionalFields = {
        productGuid: productId,
        newProductGuId: newProductId,
        changeType: downgradeType,
        cycle: BiUtils.getBiCycle(cycle),
        newCycle: BiUtils.getBiCycle(newCycle)
      };
      biLogger == null || biLogger.report(
      // 17:7901
      clickConfirmPlanChange({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onDowngradeModalClose', _ref3 => {
      let {
        productId,
        newProductId,
        downgradeType,
        cycle,
        newCycle
      } = _ref3;
      const additionalFields = {
        productGuid: productId,
        newProductGuId: newProductId,
        changeType: downgradeType,
        cycle: BiUtils.getBiCycle(cycle),
        newCycle: BiUtils.getBiCycle(newCycle)
      };
      biLogger == null || biLogger.report(
      // 17:7902
      clickCancelChangePlan({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onDowngradeModalLinkClick', _ref4 => {
      let {
        downgradeType,
        cycle,
        newCycle
      } = _ref4;
      const additionalFields = {
        changeType: downgradeType,
        cycle: BiUtils.getBiCycle(cycle),
        newCycle: BiUtils.getBiCycle(newCycle)
      };
      biLogger == null || biLogger.report(
      // 17:2238
      platformizedPackagePickerSelectPlanPageDowngradeModalLoadSrc17Evid2238({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onDowngradeErrorModalLoad', _ref5 => {
      var _module$internals$bi;
      let {
        errorType,
        errorMessage
      } = _ref5;
      const additionalFields = {
        errorType
      };
      (_module$internals$bi = module.internals.bi) == null || _module$internals$bi.onError == null || _module$internals$bi.onError({
        errorType,
        errorMessage
      });
      biLogger == null || biLogger.report(
      // 17:2259
      platformizedPackagePickerDowngradeErrorModalLoadSrc17Evid2259({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onDowngradeErrorModalClose', () => {
      biLogger == null || biLogger.report(
      // 17:2261
      platformizedPackagePickerDowngradeErrorModalCloseSrc17Evid2261({
        ...commonBiEventsFields
      }));
    });
    setBiEvent('onDowngradeErrorModalClick', _ref6 => {
      let {
        action
      } = _ref6;
      const additionalFields = {
        action
      };
      biLogger == null || biLogger.report(
      // 17:2260
      platformizedPackagePickerDowngradeErrorModalClickSrc17Evid2260({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onDowngradeSuccessModalLoad', () => {
      biLogger == null || biLogger.report(
      // 17:2257
      platformizedPackagePickerDowngradeSuccessModalLoadSrc17Evid2257({
        ...commonBiEventsFields
      }));
    });
    setBiEvent('onDowngradeSuccessModalClick', _ref7 => {
      let {
        action,
        url
      } = _ref7;
      const additionalFields = {
        action,
        url
      };
      biLogger == null || biLogger.report(
      // 17:2258
      platformizedPackagePickerDowngradeSuccessModalClickSrc17Evid2258({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setDidInit(true);
  }, [setBiEvent, biLogger, isLoading, commonBiEventsFields, module.internals, isDowngradeEnabled]);
  return {
    didInit
  };
};
//# sourceMappingURL=useInitDowngradeModalBiEvents.js.map